<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Users</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="createUser">Create User</button>
                <router-link :to="{name: 'users.create_journalist'}" class="btn-primary muted inline-block">Create Journalist</router-link>
                <router-link :to="{name: 'users.import'}" class="btn-primary muted inline-block">Import Journalists</router-link>
            </div>
        </div>
        <input type="text" v-model="$root.persist.usersSearch" class="form-field py-4 px-6" ref="searchbar" placeholder="Search for Users or Accounts" @keyup.enter="handleSearch">
        <div v-if="results.data" class="my-2 text-center">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="80%">Email</div>
                <div class="results-head" data-width="10%"></div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index">
                    <template v-if="result.usertype === 'journalist'">
                        <div class="results-cell" data-width="10%" @click="handleSelectUser(result)">{{ result.id }}</div>
                        <div class="results-cell flex" data-width="80%" @click="handleSelectUser(result)">
                            <NewspaperIcon class="h-6 w-6 text-indigo-300 mr-4" />
                            <span>{{ result.email }}</span>
                        </div>
                        <div class="results-cell flex" data-width="10%">
                            <EyeIcon class="h-6 w-6 text-gray-400 hover:text-gray-800 cursor-pointer" @click="handleSelectUser(result)" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="results-cell" data-width="10%" @click="handleUserDetail(result)">{{ result.id }}</div>
                        <div class="results-cell flex" data-width="80%" @click="handleUserDetail(result)">
                            <UserIcon class="h-6 w-6 text-orange-300 mr-4" />
                            <span>{{ result.email }}</span>
                        </div>
                        <div class="results-cell flex" data-width="10%">
                            <EyeIcon class="h-6 w-6 text-gray-400 hover:text-gray-800 cursor-pointer" @click="handleUserDetail(result)" />
                        </div>
                    </template>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="results.per_page" @paginate="loadData" :options="{hideCount: true}" ></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
    import UserView from './View'
    import Pagination from 'v-pagination-3'
    import {EyeIcon, NewspaperIcon, UserIcon} from "@heroicons/vue/24/outline"

    export default {
        name: 'Users',
        data () {
            return {
                page: 1,
                results: {},
                selectedAccount: null,
            }
        },
        components: {
            UserView,
            Pagination,
            NewspaperIcon,
            UserIcon,
            EyeIcon,
        },
        mounted() {
            if (!this.$root.persist.usersSearch) {
                window.setTimeout(function () {
                    this.$refs.searchbar.focus()
                }.bind(this), 100)
            }

            this.handleSearch()

            this.setMetaTitle('List Accounts | JournoLink Control')
        },
        methods: {
            handleSearch () {
                this.loadData()
            },
            /**
             * Load the results from the data provider
             *
             * @return {void}
             */
            loadData () {
                axios.get(route('users.list'), {
                    params: {
                        term: this.$root.persist.usersSearch,
                        page: this.page,
                    },
                })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
            },
            /**
             * Handle the selection of a user
             *
             * @param  {Object} user
             * @return {void}
             */
            handleSelectUser (user) {
                if (user.usertype !== 'admin') {
                    this.$router.push({ name: 'users.show', params: { userId: user.id } });
                }
            },

            handleUserDetail (user) {
                if (user.usertype === 'business') {
                    this.$router.push({ name: 'users.detail', params: { userId: user.id } });
                } else {
                    this.handleSelectUser(user)
                }
            },

            /**
             * create a new user
             */
            createUser () {
                this.$router.push({ name: 'users.create' });
            }
        },
        beforeRouteUpdate(to, from, next) {
            if (to && to.name === 'users.list') {
                this.loadData(1)
            }

            next()
        },
    }
</script>

<style lang="less">

</style>
